const i = {
  id: "MillionaireForLife",
  name: "Millionaire For Life®",
  style: {
    colorPrimary: "#3d8152",
    extraBall: {
      bg: "#3d8152",
      color: "#ffffff"
    }
  }
};
export {
  i as default
};
